import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDatepicker } from "@angular/material/datepicker";
import * as _moment from "moment";
import { default as _rollupMoment } from "moment";

export const MONTH_FORMATS = {
	parse: {
		dateInput: "MM/YYYY",
	},
	display: {
		dateInput: "yyyy/MM",
		monthYearLabel: "MMM YYYY",
		dateA11yLabel: "LL",
		monthYearA11yLabel: "MMMM YYYY",
	},
};

const moment = _rollupMoment || _moment;

@Component({
	selector: "app-month-picker",
	templateUrl: "./month-picker.component.html",
	styleUrls: ["./month-picker.component.scss"],
	providers: [
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
		},

		{ provide: MAT_DATE_FORMATS, useValue: MONTH_FORMATS },
	],
})
export class MonthPickerComponent implements OnInit {
	@Input() title = "Select Month";
	@Input() defaultValue: string;

	@Output() valueChangeEvent = new EventEmitter<Date>();

	formControl = new UntypedFormControl();

	constructor() {}

	ngOnInit() {
		if (!this.title) {
			this.title = "Select Month";
		}
		if (this.defaultValue != null) {
			const myDate = new Date(this.defaultValue);
			let ctrlValue = this.formControl.value;
			if (ctrlValue == null) {
				ctrlValue = moment();
			}
			console.log(ctrlValue);
			ctrlValue.month(myDate.getMonth());
			ctrlValue.year(myDate.getFullYear());
			this.formControl.setValue(ctrlValue);
			console.log(this.formControl);
		}
	}

	handleMonthChange(ev: any, dp: MatDatepicker<any>) {
		const myDate = new Date(ev);
		let ctrlValue = this.formControl.value;
		if (ctrlValue == null) {
			ctrlValue = moment();
		}
		ctrlValue.month(myDate.getMonth());
		ctrlValue.year(myDate.getFullYear());
		this.formControl.setValue(ctrlValue);
		this.valueChangeEvent.emit(this.formControl.value);
		dp.close();
	}
}
